/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForOpenstack extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForOpenstack");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForOpenstack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForOpenstack>): ServiceAccountNativeDetailsForOpenstack {
        let obj = Object.assign(new ServiceAccountNativeDetailsForOpenstack(), model);
        ServiceAccountNativeDetailsForOpenstack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForOpenstack>): ServiceAccountNativeDetailsForOpenstack {
        if (!model) return null;
        return ServiceAccountNativeDetailsForOpenstack.newInstance(<ServiceAccountNativeDetailsForOpenstack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForOpenstack) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForOpenstack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForOpenstack): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForOpenstack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForOpenstack.fixupPrototype(this.default_values);
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.OpenstackTenant.fixupPrototype(val);
            }
        }
    }

    /**
     * SelfService Default Values
     */
    default_values: models.SelfServiceDefaultValuesForOpenstack;

    /**
     * Tenants for account
     */
    tenants: Array<models.OpenstackTenant>;

}
